import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from "@angular/material/dialog";
import { Router, RouterLink } from "@angular/router";

import { AffectedSubscriptionType, Category, NotificationType } from "../../../apis/networkdashboard/graphql/graphql";
import { MalfunctionCardComponent } from "../../malfunction/malfunction-card/malfunction-card";

@Component({
  selector: "dialog-activity",
  templateUrl: "dialog-activity.html",
  styleUrls: ["dialog-activity.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MalfunctionCardComponent, RouterLink, MatDialogClose, AngularSvgIconModule, TranslatePipe],
})
export class DialogActivityComponent {
  protected data: NotificationType = inject(MAT_DIALOG_DATA);
  protected dialogRef = inject(MatDialogRef<DialogActivityComponent>);
  protected router = inject(Router);

  protected dialogTitle = computed(() => {
    switch (this.data.category) {
      case Category.Malfunction:
        return "Overview.Activities.Unplanned";
      case Category.Plannedwork:
        return "Overview.Activities.Planned";
      default:
        return "Overview.Activities.Mixed";
    }
  });

  protected dialogIcon = computed(() => {
    switch (this.data.category) {
      case Category.Malfunction:
        return "warning.svg";
      case Category.Plannedwork:
        return "activity.svg";
      default:
        return "activity.svg";
    }
  });

  closeDialog(): void {
    this.dialogRef.close();
  }

  segueToService(affectedService: AffectedSubscriptionType) {
    this.router.navigate([`/subscription/${affectedService.subscriptionId}`]);
    this.closeDialog();
  }
}
